<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>工伤数据分析</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNew">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Difference" label="差额【实际平账金额-实际赔付员工金额】" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.StatutoryAmountCompensation" label="法定赔偿金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualAmountCompensationEmployees" label="实际赔付员工金额" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualBalanceAmount" label="实际平账金额" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualAmount" label="实际到账金额【社保+商保】" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualAmountReceivedSs" label="实际到账金额【社保】" width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ActualAmountReceivedSi" label="实际到账金额【商保】" width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.DifferenceJb" label="差额（杰博亏的钱）" width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CompositionBalance" label="差额的组成" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Other" label="其他" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SocialSecurityIncome" label="社保收入" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CommercialInsuranceIncome" label="商保收入" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OtherIncome" label="其他收入" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SocialSecurityIncomeEqual" label="【支出】社保收入平账" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CommercialnsuranceRevenue" label="【支出】商保收入处平账" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.BalanceRrisk" label="【支出】风险金处平账" width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FundsJiboHeadquartersOccupied" label="【支出】提前平账后项目占用的杰博总部资金" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.CommerciaInsuranceSubmitted" label="商保报销资料是否提交公司" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="90px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1100px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="Difference">
            <template #label>
              <span>差额【实际平账金额-实际赔付员工金额】
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>差额分析：若无等级，项目会亏护理费/工伤工资/自费医疗费；</div>
                    <div class="tipsItem">若有等级，项目会赚伤残金</div>
                    <div class="tipsItem">负数代表项目亏的钱, 正数代表项目赚的钱</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.Difference" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="StatutoryAmountCompensation">
            <template #label>
              <span>法定赔偿金额
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>默认社保最低基数作为法定；</div>
                    <div class="tipsItem"><span class="agg">工伤基金出：</span>【住院伙食补助+甲类乙类药医疗费+伤残金+一次性医疗补助金+其他】</div>
                    <div class="tipsItem"><span class="agg">企业出：</span>【一次性就业补助金+工伤工资+护理费+其他】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.StatutoryAmountCompensation" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="ActualAmountCompensationEmployees">
            <template #label>
              <span>实际赔付员工金额
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=【实际赔付员工金额】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.ActualAmountCompensationEmployees" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="ActualBalanceAmount">
            <template #label>
              <span>实际平账金额
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=【平账总金额】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.ActualBalanceAmount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="ActualAmount">
            <template #label>
              <span>实际到账金额【社保+商保】
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>社保+商保</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.ActualAmount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="实际到账金额【社保】" prop="ActualAmountReceivedSs">
            <el-input v-model="formData.ActualAmountReceivedSs" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="实际到账金额【商保】" prop="ActualAmountReceivedSi">
            <el-input v-model="formData.ActualAmountReceivedSi" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="DifferenceJb">
            <template #label>
              <span>差额（杰博亏的钱）
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=实际平账金额-实际到账金额</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.DifferenceJb" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="差额的组成" prop="CompositionBalance">
            <el-input v-model="formData.CompositionBalance" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="其他" prop="Other">
            <el-input v-model="formData.Other" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="SocialSecurityIncome">
            <template #label>
              <span>社保收入
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=实际到账金额【社保】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.SocialSecurityIncome" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="CommercialInsuranceIncome">
            <template #label>
              <span>商保收入
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=实际到账金额【商保】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.CommercialInsuranceIncome" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="其他收入" prop="OtherIncome">
            <el-input v-model="formData.OtherIncome" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="SocialSecurityIncomeEqual">
            <template #label>
              <span>【支出】社保收入平账
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=【社保收入】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.SocialSecurityIncomeEqual" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="CommercialnsuranceRevenue">
            <template #label>
              <span>【支出】商保收入处平账
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=【商保收入】</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.CommercialnsuranceRevenue" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="【支出】风险金处平账" prop="BalanceRrisk">
            <template #label>
              <span>【支出】风险金处平账
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=杰博亏的钱</div>
                    <div>[解释]：风险金处平账，平的是杰博总部需要承担的钱，即杰博亏的钱</div>
                    <div class="tipsItem">【目的】参考风险金处平账金额的支出，可以用于判断“风险金计提规则”是否合理</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.BalanceRrisk" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="FundsJiboHeadquartersOccupied">
            <template #label>
              <span>【支出】提前平账后项目占用的杰博总部资金
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>=平账总金额</div>
                    <div>*只有提前平账的，才需要输入此栏，这个值每月会有变化</div>
                    <div>*已经完结的，此栏是“0”</div>
                    <div class="tipsItem">【目的】：作为了解项目占用了总部多少资金</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.FundsJiboHeadquartersOccupied" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="CommerciaInsuranceSubmitted">
            <template #label>
              <span>商保报销资料是否提交公司
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>四种情况：</div>
                    <div>1、是（商保已到账）</div>
                    <div>2、是（商保未到账）</div>
                    <div>3、否（无需提交）</div>
                    <div>4、否</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.CommerciaInsuranceSubmitted" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [{
          name: '666'
        }],
        totalCount: 0,
        roletype:localStorage.loginRoletype,
        loading: false,
        showAdd: false,
        formData: {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          Difference: '', //差额【实际平账金额-实际赔付员工金额】
          StatutoryAmountCompensation: '', //法定赔偿金额
          ActualAmountCompensationEmployees: '', //实际赔付员工金额
          ActualBalanceAmount: '', //实际平账金额
          ActualAmount: '', //实际到账金额【社保+商保】
          ActualAmountReceivedSs: '', //实际到账金额【社保】
          ActualAmountReceivedSi: '', //实际到账金额【商保】
          DifferenceJb: '', //差额杰博亏的钱
          CompositionBalance: '', //差额的组成
          Other: '', //其他
          SocialSecurityIncome: '', //社保收入
          CommercialInsuranceIncome: '', //商保收入
          OtherIncome: '', //其他收入
          SocialSecurityIncomeEqual: '', //【支出】社保收入平账
          CommercialnsuranceRevenue: '', //【支出】商保收入处平账
          BalanceRrisk: '', //【支出】风险金处平账
          FundsJiboHeadquartersOccupied: '', //【支出】提前平账后项目占用的杰博总部资金
          CommerciaInsuranceSubmitted: '', //商保报销资料是否提交公司
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请输入发生工伤时间（年-月-日）',
            trigger: 'blur'
          },
          Difference: {
            required: true,
            message: '请输入差额【实际平账金额-实际赔付员工金额】',
            trigger: 'blur'
          },
          StatutoryAmountCompensation: {
            required: true,
            message: '请输入法定赔偿金额',
            trigger: 'blur'
          },
          ActualAmountCompensationEmployees: {
            required: true,
            message: '请输入实际赔付员工金额',
            trigger: 'blur'
          },
          ActualBalanceAmount: {
            required: true,
            message: '请输入实际平账金额',
            trigger: 'blur'
          },
          ActualAmount: {
            required: true,
            message: '请输入实际到账金额【社保+商保】',
            trigger: 'blur'
          },
          ActualAmountReceivedSs: {
            required: true,
            message: '请输入实际到账金额【社保】',
            trigger: 'blur'
          },
          ActualAmountReceivedSi: {
            required: true,
            message: '请输入实际到账金额【商保】',
            trigger: 'blur'
          },
          DifferenceJb: {
            required: true,
            message: '请输入差额杰博亏的钱',
            trigger: 'blur'
          },
          CompositionBalance: {
            required: true,
            message: '请输入差额的组成',
            trigger: 'blur'
          },
          Other: {
            required: true,
            message: '请输入其他',
            trigger: 'blur'
          },
          SocialSecurityIncome: {
            required: true,
            message: '请输入社保收入',
            trigger: 'blur'
          },
          CommercialInsuranceIncome: {
            required: true,
            message: '请输入商保收入',
            trigger: 'blur'
          },
          OtherIncome: {
            required: true,
            message: '请输入其他收入',
            trigger: 'blur'
          },
          SocialSecurityIncomeEqual: {
            required: true,
            message: '请输入【支出】社保收入平账',
            trigger: 'blur'
          },
          CommercialnsuranceRevenue: {
            required: true,
            message: '请输入【支出】商保收入处平账',
            trigger: 'blur'
          },
          BalanceRrisk: {
            required: true,
            message: '请输入【支出】风险金处平账',
            trigger: 'blur'
          },
          FundsJiboHeadquartersOccupied: {
            required: true,
            message: '请输入【支出】提前平账后项目占用的杰博总部资金',
            trigger: 'blur'
          },
          CommerciaInsuranceSubmitted: {
            required: true,
            message: '请输入商保报销资料是否提交公司',
            trigger: 'blur'
          },
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
      }
    },
    created() {
      this.getWiinsuranceGroupDa5List();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiinsuranceGroupDa5List();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiinsuranceGroupDa5List();
      },
      searchHandle() {},
      //取【5】保险组-工伤数据分析列表
      getWiinsuranceGroupDa5List() {
        this.loading = true;
        xz.getWiinsuranceGroupDa5List(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增
      addNew() {
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        //取【5】保险组-工伤数据分析详情
        xz.getWiinsuranceGroupDa5(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
          } else {
            this.formData = item;
          }
          this.showAdd = true;
        })
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiinsuranceGroupDa5(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiinsuranceGroupDa5List();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //删除【3】保险组-工伤手续办理详情
      del(item) {
        xz.delWiinsuranceGroupDa5(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiinsuranceGroupDa5List();
            this.$message.success('作废成功！')
          } else {
            this.getWiinsuranceGroupDa5List();
            this.$message.error(res.msg)
          }
        })
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          Difference: '', //差额【实际平账金额-实际赔付员工金额】
          StatutoryAmountCompensation: '', //法定赔偿金额
          ActualAmountCompensationEmployees: '', //实际赔付员工金额
          ActualBalanceAmount: '', //实际平账金额
          ActualAmount: '', //实际到账金额【社保+商保】
          ActualAmountReceivedSs: '', //实际到账金额【社保】
          ActualAmountReceivedSi: '', //实际到账金额【商保】
          DifferenceJb: '', //差额杰博亏的钱
          CompositionBalance: '', //差额的组成
          Other: '', //其他
          SocialSecurityIncome: '', //社保收入
          CommercialInsuranceIncome: '', //商保收入
          OtherIncome: '', //其他收入
          SocialSecurityIncomeEqual: '', //【支出】社保收入平账
          CommercialnsuranceRevenue: '', //【支出】商保收入处平账
          BalanceRrisk: '', //【支出】风险金处平账
          FundsJiboHeadquartersOccupied: '', //【支出】提前平账后项目占用的杰博总部资金
          CommerciaInsuranceSubmitted: '', //商保报销资料是否提交公司
        }
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .agg {
    font-weight: 600;
  }

  .tipsItem {
    margin-top: 10px;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }
</style>